<template>
  <div class="progress-skills-main-container bg-main p-3">
    <section class=" container d-flex text-light justify-content-between">
      <div class="info-progress">
        <p class="text-uppercase">
          {{ title }}
        </p>
        <p class="text-big my-2">{{ completed }}/{{ total }}</p>
        <p class="text-uppercase">
          {{ subtitle }}
        </p>
      </div>
      <div class="progress--circle" :class="`progress--${percentage}`">
        <div class="progress__number">{{ percentage }}%</div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    title: String,
    subtitle: String,
    total: Number,
    completed: Number,
    percentage: Number
  }
};
</script>
<style lang="scss" scoped>
.progress-skills-main-container{
  box-shadow: 0px 4px 4px #00000029;
  z-index: 1;
}
.text-big {
  font-size: 3.8em;
  line-height: 1em;
}
$spacing: 1rem;
$themeColor: #F2CB8A;
$backColor: #f2f2f2;
$textShadow: rgba(black, 0.35) 1px 1px 1px;

* {
  box-sizing: border-box;
}

.progress--circle {
  position: relative;
  display: inline-block;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: $backColor;
  &:before {
    content: "";
    position: absolute;
    top: 5px;
    left: 5px;
    width: 110px;
    height: 110px;
    border-radius: 50%;
    background-color: var(--color-main);
  }
  &:after {
    content: "";
    display: inline-block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: $themeColor;
  }
}

.progress__number {
  position: absolute;
  top: 50%;
  width: 100%;
  line-height: 1;
  margin-top: -1rem;
  text-align: center;
  font-size: 2.3rem;
  color: #ffffff;
}

.progress--pie {
  &:before {
    display: none; /* Get rid of white circle for "pie chart style" meter */
  }
  .progress__number {
    color: white;
    text-shadow: $textShadow;
  }
}

/**
* $step is set to 5 by default, meaning you can only use percentage classes in increments of five (e.g. 25, 30, 45, 50, and so on). This helps to reduce the size of the final CSS file. If you need a number that doesn't end in 0 or 5, you can change the text percentage while rounding the class up/down to the nearest 5.
*/
$step: 1;
$loops: round(100 / $step);
$increment: 360 / $loops;
$half: round($loops / 2);
@for $i from 0 through $loops {
  .progress--bar.progress--#{$i * $step}:after {
    width: $i * $step * 1%;
  }
  .progress--circle.progress--#{$i * $step}:after {
    @if $i < $half {
      $nextDeg: 90deg + ($increment * $i);
      background-image: linear-gradient(
          90deg,
          $backColor 50%,
          transparent 50%,
          transparent
        ),
        linear-gradient($nextDeg, $themeColor 50%, $backColor 50%, $backColor);
    } @else {
      $nextDeg: -90deg + ($increment * ($i - $half));
      background-image: linear-gradient(
          $nextDeg,
          $themeColor 50%,
          transparent 50%,
          transparent
        ),
        linear-gradient(270deg, $themeColor 50%, $backColor 50%, $backColor);
    }
  }

  @media (max-width: 420px) {
    .text-big {
      font-size: 3.5em;
    }
    .info-progress {
      width: 45%;
    }
  }
}
</style>
